import { CAPABILITIES_LINE_COLOR, GRAPH_LABEL_FADE_DURATION_MS } from './graphConstants'
import type { ExtrapolatedGraphAnnotation, GraphPoint } from './types'

const AI_CAPABILITIES_LABEL_LINE_GAP_PX = 6

// Horizontal nudge from the curve's leftmost visible point. 0 keeps the label
// flush with the plot's left edge, aligned with the dither field and the HUD
// panel content below the graph.
const AI_CAPABILITIES_LABEL_LEFT_NUDGE_PX = 0

const AICapabilitiesLabel = ({ fontSize }: { fontSize: number }) => {
  const aiCapabilitiesLabelStyle = {
    display: 'inline-block' as const,
    fontWeight: 'bold' as const,
    fontSize,
    color: CAPABILITIES_LINE_COLOR,
  }
  return (
    <span style={aiCapabilitiesLabelStyle}>
      AI CAPABILITIES
    </span>
  )
}

export const createAICapabilitiesLabelAnnotation = ({
  leftmostPastLinePoint,
  xForTimestamp,
  yForValue,
  fontSize,
}: {
  leftmostPastLinePoint?: GraphPoint
  xForTimestamp: (timestamp: number) => number
  yForValue: (value: number) => number
  fontSize: number
}): ExtrapolatedGraphAnnotation | undefined =>
  leftmostPastLinePoint
    ? {
      key: 'ai-capabilities-label',
      x: xForTimestamp(leftmostPastLinePoint.timestamp)
        + AI_CAPABILITIES_LABEL_LEFT_NUDGE_PX,
      y: yForValue(leftmostPastLinePoint.value) - AI_CAPABILITIES_LABEL_LINE_GAP_PX,
      text: <AICapabilitiesLabel fontSize={fontSize} />,
      transform: 'translateY(-100%)',
      // Let hover fall through to the graph's whole-graph tooltip anchor
      // (the label renders in a portal layer above it).
      pointerEvents: 'none',
      transitionDurationMs: GRAPH_LABEL_FADE_DURATION_MS,
    }
    : undefined
